import { Request } from 'components/Request.jsx';
import requestErrorMessage from 'functions/requestErrorMessage';
import { markSearchTimerRestarted } from 'react/matchmaking/unified/header/searchClock';

// The requests a doubles lobby makes, from the panel's lobby step and the
// status line. Each resolves with the response or rejects with the reason to
// show.

function checked(request) {
	return request.then((response) => {
		if(response?.error) {
			return Promise.reject(requestErrorMessage(response));
		}
		if(response?.invite?.error) {
			return Promise.reject(response.invite.error);
		}
		return response;
	}, (failure) => Promise.reject(failure?.responseJSON?.invite?.error || requestErrorMessage(failure)));
}

function modifyPlayer(match, player, type) {
	return checked(Request.apiv1('match/modify_match_player', { match_id: match.id, player_id: player.id, type }));
}

// The host answers a join request. Declining a joined player kicks them: they
// can't rejoin this lobby.
export const acceptPlayer = (match, player) => modifyPlayer(match, player, 'accept');
export const declinePlayer = (match, player) => modifyPlayer(match, player, 'decline');
export const uninvitePlayer = (match, player) => modifyPlayer(match, player, 'uninvite');

export function startTeamMatch(match) {
	return checked(Request.post(`${siteUrl}/matchmaking/start_match`, { match_id: match.id }));
}

// Moves me to a team, or, for the host, another player in the lobby.
export function selectTeam(match, teamNumber, player = null) {
	const body = { match_id: match.id, team_number: teamNumber };
	if(player) {
		body.player_id = player.id;
	}
	return checked(Request.post(`${siteUrl}/match/select_team_number`, body));
}

export function setExtraLocalPlayers(match, count) {
	return checked(Request.apiv1('match/local_team_size', { match_id: match.id, extra_local_players: count }));
}

export function restartSearch(match) {
	markSearchTimerRestarted(match.id);
	return checked(Request.apiv1('match/restart_search_timer', { match_id: match.id }));
}

// Players whose name matches, an exact (case-insensitive) match first.
export function findPlayersNamed(name) {
	const wanted = String(name || '').trim().toLowerCase();
	return Request.apiv1Get('player/search', { search: name }).then((response) => {
		const players = Object.values(response?.users || {});
		return players.sort((first, second) => (String(second.username).toLowerCase() === wanted) - (String(first.username).toLowerCase() === wanted));
	});
}

export function invitePlayer(match, player) {
	return checked(Request.post(`${siteUrl}/chats/invite_player`, { match_id: match.id, player_id: player.id }));
}
